export default {
  watch: {
    $route() {
      if (this.$store.state.app.windowWidth < this.$store.state.app.breakpoints.xl) {
        this.isVerticalMenuActive = false
      }
    },
  },
}
